import { graphql } from '@/gql/graphql';
import { EventListItemInfoFragment } from './EventListItemInfo';
import {
  EventListItemTeamsFragment,
  EventListItemTeamsRsvpFragment,
} from './EventListItemTeams';
import { EventListItemTimeFragment } from './EventListItemTime';
import { EventRsvpPickerFragment } from './EventRsvpPicker.types';

export const EventListItemFragment = graphql(/* GraphQL */ `
  fragment EventListItem on event {
    id
    datetime
    status
    event_clock {
      event_id
    }
    ...EventRsvpPicker
    ...EventListItemTime
    ...EventListItemTeams
    ...EventListItemTeamsRsvp
    ...EventListItemInfo
  }
`, [
  EventRsvpPickerFragment,
  EventListItemTimeFragment,
  EventListItemTeamsFragment,
  EventListItemTeamsRsvpFragment,
  EventListItemInfoFragment,
]);
